import React from 'react';
import { View } from 'react-native';
import { PRScrollView } from '../Scroll';
import Stack, { contentStackSpacing } from '../../v2BaseComponents/Stack';
import PressableDynamicOpacity from '../../v2BaseComponents/PressableDynamicOpacity';
import { hexToRgbA } from '../../../utils/hexToRGBA';
import { colors } from '../../../utils/theme';
import Text from '../../v2BaseComponents/Text';
import { getIntl } from '../../../utils/intl';
import { mainContentPadding } from '../../v2BaseComponents/MainContentContainer';
import Icon, { IconName } from '../../v2BaseComponents/Icon';

const intl = getIntl('SearchHistory', {
    recentSearches: 'Recent Searches',
    askTheChatAssistant: 'Ask the chat assistant',
    actions: 'Actions',
});

export type SearchHistoryOwnProps = {
    onSetSearchText: (searchText: string) => void;
    searchHistory: string[];
    onPromptChat: () => void;
};

export type SearchHistoryProps = SearchHistoryOwnProps;

const SearchHistory: React.FC<SearchHistoryProps> = (props) => {
    const renderListItem = ({
        testId,
        text,
        onPress,
        key,
        icon,
    }: {
        testId: string;
        text: string;
        onPress: () => void;
        key: string;
        icon?: IconName;
    }) => (
        <PressableDynamicOpacity
            key={key}
            onPress={onPress}
            testID={testId}
            style={{
                flex: 1,
                borderRadius: 4,
            }}
            addHoverEffect
            customStateStyles={{
                hovered: {
                    backgroundColor: hexToRgbA(colors['Grey-Light'], 0.2),
                },
                pressed: {
                    backgroundColor: hexToRgbA(colors['Grey-Light'], 0.5),
                },
            }}
            hoverDetectionContainerStyles={{
                alignSelf: 'stretch',
            }}
        >
            <Stack horizontal flex={1} align="center" justify="flex-start" style={{ padding: 4 }} space={4}>
                <Text variant="bold-h5" wrapText>
                    {text}
                </Text>
                {icon ? <Icon name={icon} size="minimal-button-icon" /> : null}
            </Stack>
        </PressableDynamicOpacity>
    );

    return (
        <View
            style={{
                flex: 1,
                alignSelf: 'stretch',
                padding: mainContentPadding,
            }}
        >
            <PRScrollView
                style={{
                    flex: 1,
                    alignSelf: 'stretch',
                }}
            >
                <Stack space={contentStackSpacing} vertical style={{ alignSelf: 'stretch' }}>
                    <Text variant="bold-body-1" color="Primary-Reg">
                        {intl('actions')}
                    </Text>
                    {renderListItem({
                        key: 'prompt-chat-with-search-text',
                        testId: 'prompt-chat-from-empty-list',
                        text: intl('askTheChatAssistant'),
                        onPress: props.onPromptChat,
                        icon: 'AISparkle',
                    })}
                    <Text variant="bold-body-1" color="Primary-Reg">
                        {intl('recentSearches')}
                    </Text>
                    {props.searchHistory.map((searchText, index) =>
                        renderListItem({
                            key: `${searchText}-${index}`,
                            testId: 'profile-search-history-item',
                            text: searchText,
                            onPress: () => props.onSetSearchText(searchText),
                        }),
                    )}
                </Stack>
            </PRScrollView>
        </View>
    );
};

export default React.memo(SearchHistory);
